import { useRouter } from 'next/router'

import { useAppSelector } from '~/redux/hooks'

import { selectCurrentActivityType } from '../slices/bootcamp-activity.slice'
import { selectVccLevelActivities } from '../slices/vcc-data.slice'

// This hook is used to get the next activity type
function useNextActivityType(): number {
  const { query } = useRouter()
  const activityType = useAppSelector(selectCurrentActivityType)

  const levelActivities = useAppSelector(selectVccLevelActivities) || {}
  const levelTotalActivitySets = levelActivities[query.level as string] || 0

  const nextActivityType = activityType < levelTotalActivitySets ? activityType + 1 : 0

  return nextActivityType
}

export default useNextActivityType
